export default __webpack_public_path__ + "static/media/Enlightening Atlantean Catalyst.0f7ba4f8.jpg";